<template>
    <div class="spo-card rounded bordered p-1 my-2">
        <div class="text-h6 ">Alerte de suivi par SMS</div>
        <v-checkbox v-if="!is_changement_parcours" color="primary-dark" hide-details @change="$emit('changeAlerteSMS')"
            :label="'Souscrire au suivi SMS pour ' + alerte_sms.prix + '€'" v-model="alerte_sms.selected"></v-checkbox>
        Tenez informés jusqu'à 3 de vos accompagnants. Du départ à l'arrivée, ils seront informés par SMS (numéros
        français uniquement) de vos passages intermédiaires et vos estimations aux points suivants jusqu'au classement
        d'arrivée. En cas d'abandon, on les
        prévient aussi. Vous pourrez renseigner/modifier les numéros de téléphone de vos accompagnants dans votre fiche
        coureur
        jusqu'au jour de la course.
    </div>
</template>

<script>
export default {
    props: ["item", "initial_commande_inscription"],
    data() {
        return {
            alerte_sms: {},
            showDialogAlerteSMS: false,
        };
    },
    computed: {
        is_changement_parcours() {
            return this.initial_commande_inscription;
        },
        has_already_alerte_sms() {
            return this.initial_commande_inscription && this.initial_commande_inscription.alerte_sms && this.initial_commande_inscription.alerte_sms.selected == "1";
        },
    },
    mounted() {
        this.alerte_sms = this.item;
    },

}
</script>

<style lang="scss" scoped></style>